import { boot } from '@dazn/bootstrap-lib';

import { chapterNames } from './constants';

/**
 * Normalise Chapter Name
 *
 * in the runtime configuration there are chapter names
 * that are not the same we use here internally. This
 * function aims to fix them.
 */
const normalisationMap = {
    landing: chapterNames.LANDING_PAGE,
    myAccount: chapterNames.MY_ACCOUNT,
} as const;

export const normalizeRuntimeChapterName = (
    chapterName: boot.config.ChapterName | keyof typeof normalisationMap,
): boot.config.ChapterName =>
    chapterName in normalisationMap
        ? // @ts-expect-error FIXME: `in` is not a type guard
          // https://github.com/microsoft/TypeScript/issues/21732
          normalisationMap[chapterName]
        : chapterName;
